export const formatPhoneNumber = (phoneNumber) => {
  phoneNumber = phoneNumber.replace(' ', '-');
  phoneNumber = phoneNumber.replace(/ /g, '');
  return phoneNumber;
};
